const Row = ({ children, className }) => {
    return (
        <div className={`flex flex-wrap md:-mx-3 -mx-5 ${className}`}>
            {children}
        </div>
    );
}

export default Row;